import React from 'react'

import { IProductDetailsList } from '../graphql/sections/productDetailsList'

import ProductDetails from './ProductDetailsSection'
import Section from '../components/Section'
import { Heading } from '../components/typography'
import CreditCardDetails from './CreditCardDetailsSection'
import { useLocale } from '../context/LocaleContextProvider'
import { filterHiddenInFrench } from '../helpers/hideInFrench'

interface IProps {
  data: IProductDetailsList
}

const ProductDetailsListSection: React.FC<IProps> = ({ data }) => {
  const { products: productDetailsList, ctaCopy, creditCards, shouldDisplayTitle } = data
  const sectionTitle = data.title
  const { isFrench } = useLocale()

  return (
    <Section title={sectionTitle}>
      {shouldDisplayTitle && <Heading as="h2">{sectionTitle}</Heading>}
      {productDetailsList?.map(productElement => {
        return (
          <ProductDetails
            ctaCopy={ctaCopy}
            key={productElement.knackId}
            id={productElement.knackId}
            data={productElement}
          />
        )
      })}
      {filterHiddenInFrench(creditCards, isFrench).map(creditCard => {
        return <CreditCardDetails key={creditCard.contentful_id} data={creditCard} />
      })}
    </Section>
  )
}

export default ProductDetailsListSection
